import { AccountData, Event, ThemeType } from "@markit/common.types";
import { ReactNode, useMemo } from "react";
import { useTheme } from "../../../../hooks/useTheme";
import { isDesktop } from "react-device-detect";
import FullProductHeaderSection from "./FullProductHeaderSection";
import ReadOnlyRichTextEditor from "../../../TextFields/ReadOnlyRichTextEditor";

type FullPostContentProps = {
  post: Event;
  creatorData: AccountData;
  hardTheme: ThemeType;
  hiddenModalComp?: ReactNode; // To have it absolute positioned to the actual content
};

const FullPostContent = (props: FullPostContentProps) => {
  const { post, creatorData, hardTheme, hiddenModalComp } = props;
  const { theme } = useTheme(hardTheme);

  const isHidden = useMemo(() => !!hiddenModalComp, [hiddenModalComp]);

  return (
    <div
      style={{
        minHeight: isHidden ? undefined : "60vh",
        paddingInline: 14,
        marginInline: "auto",
        width: isDesktop ? 700 : undefined,
      }}
    >
      <div className="ColumnNormal" style={{ gap: isDesktop ? 24 : 14 }}>
        <FullProductHeaderSection
          product={post}
          creatorData={creatorData}
          hardTheme={hardTheme}
        />
        <div style={{ position: "relative" }}>
          <div
            style={{
              height: isHidden ? 400 : undefined,
              boxShadow: isHidden ? "10px 20px 20px grey" : "none",
              overflow: isHidden ? "hidden" : undefined,
              filter: isHidden ? "blur(1.5px)" : "none",
              maskImage: isHidden
                ? `linear-gradient(to bottom, rgba(0,0,0,${
                    hardTheme === ThemeType.Light ? 0.4 : 0.6
                  }) 0%, rgba(0,0,0,0) 22%`
                : "none",
              WebkitMaskImage: isHidden
                ? `linear-gradient(to bottom, rgba(0,0,0,${
                    hardTheme === ThemeType.Light ? 0.4 : 0.6
                  }) 0%, rgba(0,0,0,0) 22%`
                : "none",
            }}
          >
            <ReadOnlyRichTextEditor
              body={post.body}
              theme={theme}
              addImageExtension
              className={`post-content-editor ${
                isDesktop ? "" : "mobile-editor"
              }`}
              editorStyle={{
                userSelect: isHidden ? "none" : "auto",
                WebkitUserSelect: isHidden ? "none" : "auto" /* Safari */,
                pointerEvents: isHidden ? "none" : "auto",
              }}
            />
          </div>
          {hiddenModalComp || null}
        </div>
      </div>
    </div>
  );
};

export default FullPostContent;
